// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1S6Hb","content":"styles_content__2b_4b","checkbox":"styles_checkbox__1rMmQ","checkboxLabel":"styles_checkboxLabel__3qU5U"};